import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { HcButton } from '@hotmart-org-ca/cosmos-web/dist/react/hc-button';
export const Button = forwardRef(function Button({ icon, children, type = 'button', target, ...props }, ref) {
    return (_jsxs(HcButton, { ref: ref, role: "button", type: type, target: target, ...(target === '_blank' && { rel: 'noreferrer noopener' }), ...props, children: [icon && _jsx("div", { slot: "icon", children: icon }), children] }));
});
